import React, { useState, useMemo } from 'react';

const HelpIcon = ({ text }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: rect.right + 10, y: rect.top - 10 });
    setShowPopup(true);
  };
  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <span onMouseEnter={handleMouseEnter} onMouseLeave={() => setShowPopup(false)} style={{ display: 'inline-block', marginLeft: '6px', width: '18px', height: '18px', backgroundColor: '#0066cc', color: 'white', borderRadius: '50%', textAlign: 'center', lineHeight: '18px', fontSize: '12px', fontWeight: 'bold', cursor: 'help' }}>?</span>
      {showPopup && <div onMouseEnter={() => setShowPopup(true)} onMouseLeave={() => setShowPopup(false)} style={{ position: 'fixed', top: `${position.y}px`, left: `${position.x}px`, background: '#1e293b', border: '2px solid #0066cc', borderRadius: '8px', padding: '12px 16px', maxWidth: '280px', color: '#e5e7eb', fontSize: '13px', lineHeight: '1.5', zIndex: 9999, boxShadow: '0 8px 24px rgba(0,0,0,0.6)', pointerEvents: 'auto' }}>{text}</div>}
    </div>
  );
};

const ProductModal = ({ product, tier, onClose, onSelect }) => {
  const trackView = () => {
    const views = JSON.parse(localStorage.getItem('productViews') || '[]');
    views.push({ type: 'solar', tier, product: product.name, timestamp: new Date().toISOString() });
    localStorage.setItem('productViews', JSON.stringify(views));
  };
  
  React.useEffect(() => { trackView(); }, []);
  
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#1e293b', border: '2px solid #0066cc', borderRadius: '12px', padding: '20px', maxWidth: '500px', width: '90%', color: '#e5e7eb', boxShadow: '0 10px 40px rgba(0,0,0,0.8)' }} onClick={e => e.stopPropagation()}>
        <div style={{ width: '100%', height: '180px', background: product.color, borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px' }}>{product.image}</div>
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#10b981' }}>{product.name}</h3>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#94a3b8' }}>{product.brand}</p>
        <div style={{ fontSize: '13px', color: '#e5e7eb', marginBottom: '16px', lineHeight: '1.6' }}>
          <div>⚡ Efficiency: {product.efficiency}%</div>
          <div>📋 Warranty: {product.warranty} years</div>
          <div>💰 Cost: £{product.cost.toLocaleString()}</div>
          <div style={{ marginTop: '12px', color: '#94a3b8' }}>{product.description}</div>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { onSelect(product); onClose(); }} style={{ flex: 1, background: '#10b981', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer', fontWeight: 500 }}>Select This</button>
          <button onClick={onClose} style={{ flex: 1, background: '#334155', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

const solarProducts = {
  low: [
    { name: 'Trina TSM-400', brand: 'Trina Solar', efficiency: '16.8%', warranty: 10, cost: 3100, color: '#3b82f6', image: '🟦 Trina', description: 'Budget-friendly, proven reliability. Takes 2-3 years longer to break even.' },
    { name: 'JinkoSolar Eagle', brand: 'Jinko Solar', efficiency: '17.2%', warranty: 10, cost: 3200, color: '#6366f1', image: '🟦 Jinko', description: 'Good balance. Lower efficiency, lower cost.' },
    { name: 'Canadian Solar CS6W', brand: 'Canadian Solar', efficiency: '16.9%', warranty: 10, cost: 3150, color: '#8b5cf6', image: '🟦 Canadian', description: 'Entry-level. Reliable for 20+ years.' }
  ],
  medium: [
    { name: 'Trina TSM-450', brand: 'Trina Solar', efficiency: '18.5%', warranty: 15, cost: 3825, color: '#06b6d4', image: '🟩 Trina', description: 'Industry standard. Best value. Most popular choice.' },
    { name: 'JinkoSolar Tiger Pro', brand: 'Jinko Solar', efficiency: '18.9%', warranty: 12, cost: 3900, color: '#10b981', image: '🟩 Jinko', description: 'Higher efficiency. Smaller footprint. Great performance.' },
    { name: 'LG NeON R', brand: 'LG', efficiency: '18.7%', warranty: 15, cost: 3850, color: '#14b8a6', image: '🟩 LG', description: 'Premium mid-range. Excellent warranty.' }
  ],
  premium: [
    { name: 'SunPower A-Series', brand: 'SunPower', efficiency: '21.5%', warranty: 25, cost: 4600, color: '#f59e0b', image: '🟨 SunPower', description: 'Maximum efficiency. 25-year warranty. Premium aesthetics. Break even in 7 years.' },
    { name: 'LG NeON H', brand: 'LG', efficiency: '20.9%', warranty: 20, cost: 4400, color: '#f97316', image: '🟨 LG', description: 'High efficiency + durability. Premium brand. Recoup cost via higher output.' },
    { name: 'Panasonic Evervolt', brand: 'Panasonic', efficiency: '21.1%', warranty: 20, cost: 4500, color: '#fb923c', image: '🟨 Panasonic', description: 'Japanese engineering. Lasts 30+ years. Best long-term value.' }
  ]
};

export default function SolarCalculator() {
  const [inputs, setInputs] = useState({ postcode: 'SW1A1AA', propertyType: '3bed-semi', roofOrientation: 'south', roofPitch: 35, roofAccess: 'standard', annualUsage: 3500, addBattery: false, batterySize: 10 });
  const [selectedTier, setSelectedTier] = useState('medium');
  const [selectedProduct, setSelectedProduct] = useState(solarProducts.medium[0]);
  const [showModal, setShowModal] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const regionMap = { 'SW': 1.0, 'SE': 1.12, 'E': 1.05, 'N': 0.95, 'NW': 0.95, 'M': 1.0, 'W': 0.98, 'WM': 0.98, 'EE': 1.02, 'Y': 0.95, 'NE': 0.92, 'SC': 0.95, 'WA': 0.95, 'EW': 0.95, 'GL': 1.0 };
  const regionCode = inputs.postcode.substring(0, 2).toUpperCase();
  const regionMultiplier = regionMap[regionCode] || 1.0;

  const systemSize = useMemo(() => { const usage = inputs.annualUsage; if (usage < 2500) return 3.0; if (usage < 3500) return 3.5; if (usage < 4500) return 4.5; if (usage < 5500) return 5.5; return 6.5; }, [inputs.annualUsage]);

  const tierMultipliers = { low: 0.85, medium: 1.0, premium: 1.25 };
  const basePanelCost = systemSize * 850;
  const panelCost = basePanelCost * tierMultipliers[selectedTier];
  const inverterCost = { low: 1000, medium: 1200, premium: 1500 }[selectedTier];
  const wiringCost = 450;
  const mountingCost = 600;
  const laborCost = Math.max(2000, systemSize * 800 * regionMultiplier);
  
  let scaffoldingCost = 500;
  if (inputs.roofPitch > 45) scaffoldingCost = 900;
  if (inputs.roofAccess === 'difficult') scaffoldingCost = 1200;
  if (inputs.propertyType === 'terraced') scaffoldingCost += 200;
  
  const birdProtection = inputs.roofOrientation === 'south' ? 600 : 300;
  const buildingControl = 300;
  const epc = 100;
  
  let materialsSubtotal = panelCost + inverterCost + wiringCost + mountingCost;
  let laborSubtotal = laborCost + scaffoldingCost + birdProtection;
  
  let batteryMatCost = 0, batteryLabCost = 0;
  if (inputs.addBattery) {
    const batterySize = inputs.batterySize || 10;
    batteryMatCost = batterySize <= 5 ? 2500 : (batterySize <= 10 ? 3500 : 5500);
    batteryLabCost = 800;
  }
  
  materialsSubtotal += batteryMatCost;
  const subtotalBeforeVAT = materialsSubtotal + laborSubtotal + buildingControl + epc;
  const totalCost = subtotalBeforeVAT;
  
  const projections = useMemo(() => {
    const selfConsumption = inputs.addBattery ? 0.65 : 0.35;
    const annualGeneration = systemSize * 850;
    const selfConsumed = annualGeneration * selfConsumption;
    const exported = annualGeneration * (1 - selfConsumption);
    const billSavings = selfConsumed * 0.26;
    const segEarnings = exported * 0.10;
    const annualSavings = billSavings + segEarnings;
    let batterySavings = 0;
    if (inputs.addBattery) batterySavings = (inputs.batterySize || 10) * 35;
    const annualSavingsWithBattery = annualSavings + batterySavings;
    const payback = totalCost / Math.max(1, annualSavingsWithBattery);
    const savings25yr = annualSavingsWithBattery * 25 * 1.02;
    const roi = (savings25yr / totalCost - 1) * 100;
    
    return { annualGeneration: Math.round(annualGeneration), billSavings: Math.round(billSavings), segEarnings: Math.round(segEarnings), annualSavings: Math.round(annualSavingsWithBattery), batterySavings: Math.round(batterySavings), payback: Math.round(payback * 10) / 10, savings25yr: Math.round(savings25yr), roi: Math.round(roi) };
  }, [inputs, totalCost]);

  const handleInputChange = (key, value) => { setInputs(prev => ({ ...prev, [key]: value })); };

  return (
    <div>
      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Property Details <HelpIcon text="Tell us about your home. We calculate system size, installation cost & 25-year savings." /></h3>
        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">Postcode <HelpIcon text="Full UK postcode. First 2 letters determine local labor rates." /></label>
            <input type="text" className="solar-input" value={inputs.postcode} onChange={(e) => handleInputChange('postcode', e.target.value.toUpperCase())} placeholder="e.g., SW1A1AA" />
          </div>
          <div className="solar-input-group">
            <label className="solar-label">Property type <HelpIcon text="Detached = easier. Terraced = more scaffolding." /></label>
            <select className="solar-input" value={inputs.propertyType} onChange={(e) => handleInputChange('propertyType', e.target.value)}>
              <option value="detached">Detached house</option>
              <option value="3bed-semi">Semi-detached</option>
              <option value="terraced">Terraced house</option>
              <option value="flat">Flat</option>
              <option value="bungalow">Bungalow</option>
            </select>
          </div>
        </div>
        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">Roof orientation <HelpIcon text="South = best. East/West = 85%." /></label>
            <select className="solar-input" value={inputs.roofOrientation} onChange={(e) => handleInputChange('roofOrientation', e.target.value)}>
              <option value="south">South-facing (100%)</option>
              <option value="southeast">Southeast (95%)</option>
              <option value="southwest">Southwest (95%)</option>
              <option value="east">East-facing (85%)</option>
              <option value="west">West-facing (85%)</option>
              <option value="flat">Flat roof (80%)</option>
            </select>
          </div>
          <div className="solar-input-group">
            <label className="solar-label">Roof pitch (degrees) <HelpIcon text="0°=flat, 25°=gentle, 35°=typical, 45°+=steep." /></label>
            <input type="number" className="solar-input" value={inputs.roofPitch} onChange={(e) => handleInputChange('roofPitch', parseFloat(e.target.value))} min="0" max="60" />
          </div>
        </div>
        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">Roof access <HelpIcon text="Easy vs difficult affects scaffolding cost." /></label>
            <select className="solar-input" value={inputs.roofAccess} onChange={(e) => handleInputChange('roofAccess', e.target.value)}>
              <option value="standard">Standard (easy access)</option>
              <option value="moderate">Moderate</option>
              <option value="difficult">Difficult (narrow drive, high pitch)</option>
            </select>
          </div>
          <div className="solar-input-group">
            <label className="solar-label">Annual electricity use (kWh) <HelpIcon text="Find on bill. Typical: 3-bed=3,500 kWh/year." /></label>
            <input type="number" className="solar-input" value={inputs.annualUsage} onChange={(e) => handleInputChange('annualUsage', parseInt(e.target.value))} min="1000" max="10000" />
          </div>
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Select System Tier <HelpIcon text="LOW = budget entry. MEDIUM = best value (recommended). PREMIUM = maximum efficiency & warranty." /></h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '1rem' }}>
          {['low', 'medium', 'premium'].map(tier => (
            <div key={tier} onClick={() => setSelectedTier(tier)} style={{ background: selectedTier === tier ? '#0066cc' : '#334155', border: '2px solid ' + (selectedTier === tier ? '#10b981' : '#475569'), borderRadius: '8px', padding: '12px', cursor: 'pointer', textAlign: 'center', color: '#e5e7eb', fontWeight: selectedTier === tier ? 600 : 400 }}>
              <div style={{ textTransform: 'uppercase', fontSize: '14px', marginBottom: '4px' }}>{tier}</div>
              <div style={{ fontSize: '12px', color: selectedTier === tier ? '#a7f3d0' : '#cbd5e1' }}>-15% to +25% cost</div>
            </div>
          ))}
        </div>

        <h4 style={{ margin: '1rem 0 0.5rem', fontSize: '14px', color: '#94a3b8' }}>Featured Products - {selectedTier.toUpperCase()}</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '1rem' }}>
          {solarProducts[selectedTier].map((product, i) => (
            <div key={i} onClick={() => setShowModal(product)} style={{ background: '#334155', border: '1px solid #475569', borderRadius: '8px', padding: '12px', cursor: 'pointer', textAlign: 'center' }}>
              <div style={{ width: '100%', height: '100px', background: product.color, borderRadius: '6px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>{product.image}</div>
              <div style={{ fontSize: '12px', fontWeight: 500, color: '#e5e7eb' }}>{product.brand}</div>
              <div style={{ fontSize: '11px', color: '#94a3b8' }}>{product.efficiency} • {product.warranty}yr</div>
              <button onClick={(e) => { e.stopPropagation(); setShowModal(product); }} style={{ marginTop: '8px', width: '100%', background: '#0066cc', border: 'none', borderRadius: '6px', padding: '6px', color: 'white', fontSize: '11px', cursor: 'pointer' }}>View Details</button>
            </div>
          ))}
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Battery Storage <HelpIcon text="Optional. Store solar for evening use. Increase savings by 35%." /></h3>
        <label>
          <input type="checkbox" checked={inputs.addBattery} onChange={(e) => handleInputChange('addBattery', e.target.checked)} />
          <span style={{ marginLeft: '8px', fontSize: '14px' }}>Add battery storage?</span>
        </label>
        {inputs.addBattery && (
          <div style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <label className="solar-label">Battery size (kWh)</label>
            <select className="solar-input" value={inputs.batterySize} onChange={(e) => handleInputChange('batterySize', parseInt(e.target.value))}>
              <option value="5">5 kWh (small)</option>
              <option value="10">10 kWh (typical)</option>
              <option value="15">15 kWh (large)</option>
            </select>
          </div>
        )}
      </div>

      {inputs.roofOrientation === 'south' && (
        <div className="solar-warning">🐦 <strong>Bird protection added.</strong> South-facing = nesting birds. Netting (~£600) included.</div>
      )}

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>System Overview</h3>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Recommended size</div>
            <div className="solar-metric-value">{systemSize} kWp</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">Annual generation</div>
            <div className="solar-metric-value">{projections.annualGeneration} kWh</div>
          </div>
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Total Cost ({selectedTier.toUpperCase()})</h3>
        <div style={{ marginBottom: '1.5rem' }}>
          <div className="solar-row">
            <span>Solar panels (selected: {selectedProduct.brand})</span>
            <span className="solar-currency">£{Math.round(panelCost).toLocaleString()}</span>
          </div>
          <div className="solar-row">
            <span>Inverter & wiring</span>
            <span className="solar-currency">£{Math.round(inverterCost + wiringCost).toLocaleString()}</span>
          </div>
          <div className="solar-row">
            <span>Installation labor</span>
            <span className="solar-currency">£{Math.round(laborCost).toLocaleString()}</span>
          </div>
          <div className="solar-row">
            <span>Scaffolding & access</span>
            <span className="solar-currency">£{Math.round(scaffoldingCost).toLocaleString()}</span>
          </div>
          <div className="solar-row">
            <span>Bird protection netting</span>
            <span className="solar-currency">£{Math.round(birdProtection).toLocaleString()}</span>
          </div>
          {inputs.addBattery && <div className="solar-row"><span>Battery storage</span><span className="solar-currency">£{Math.round(batteryMatCost + batteryLabCost).toLocaleString()}</span></div>}
          <div style={{ borderTop: '2px solid #334155', paddingTop: '12px', marginTop: '12px' }}>
            <div className="solar-row" style={{ fontSize: '16px', fontWeight: 600, color: '#10b981' }}>
              <strong>YOUR NET COST (0% VAT)</strong>
              <span className="solar-currency"><strong>£{Math.round(totalCost).toLocaleString()}</strong></span>
            </div>
          </div>
        </div>
        <button className="solar-btn" onClick={() => setShowDetails(!showDetails)} style={{ width: '100%' }}>
          {showDetails ? '▼' : '▶'} {showDetails ? 'Hide' : 'Show'} breakdown
        </button>
        {showDetails && (
          <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '0.5px solid #334155', fontSize: '13px' }}>
            <div className="solar-row"><span>Materials</span><span>£{Math.round(materialsSubtotal).toLocaleString()}</span></div>
            <div className="solar-row"><span>Labor & logistics</span><span>£{Math.round(laborSubtotal).toLocaleString()}</span></div>
            <div className="solar-row"><span>Region multiplier</span><span>×{regionMultiplier.toFixed(2)}</span></div>
          </div>
        )}
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>25-Year Projection</h3>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Annual savings</div>
            <div className="solar-currency" style={{ fontSize: '22px' }}>£{projections.annualSavings.toLocaleString()}</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">Payback period</div>
            <div className="solar-metric-value">{projections.payback} yrs</div>
          </div>
        </div>
        <div className="solar-metric" style={{ marginTop: '12px' }}>
          <div className="solar-metric-label">Total savings</div>
          <div className="solar-currency" style={{ fontSize: '28px' }}>£{projections.savings25yr.toLocaleString()}</div>
        </div>
        <div className="solar-metric" style={{ marginTop: '12px', background: '#064e3b' }}>
          <div className="solar-metric-label" style={{ color: '#a7f3d0' }}>ROI</div>
          <div style={{ fontSize: '28px', fontWeight: 600, color: '#10b981' }}>{projections.roi}%</div>
        </div>
      </div>

      {showModal && <ProductModal product={showModal} tier={selectedTier} onClose={() => setShowModal(null)} onSelect={(p) => setSelectedProduct(p)} />}
    </div>
  );
}